import React, { useContext } from 'react';
import Header from '../common/Header';
import LiteralDisplay from './LiteralDisplay';
import FieldDisplay from './FieldDisplay';
import LocaleContext from 'constants/localization';
import { getResourceFields, isObject } from 'helpers/objectHelpers';
import ObjectLink from './resource/ObjectLink';

/**
 * Default recursive display of resources.
 */
export default function ResourceDisplay({field, mode, shaded, depth}) {
  const { values, props } = field;
  const LS = useContext(LocaleContext);

  if (!values || values.length < 1) {
    return null;
  }

  depth = depth || 0;

  const isPrintMode = mode === 'print';

  // By default, display links are enabled. props.noLink may be used
  // in edit mode.
  const displayLinksEnabled = props && !props.noLink && !isPrintMode;

  // Invert shading based on parent shading.
  let isShaded = !shaded;
  if (isPrintMode) {
    isShaded = false;
  }
  const style = getStyle(isShaded, depth);

  const NestedResource = ({ value }) => {
    const fields = getResourceFields(value);
    if (!fields || fields.length === 0) {
      return (
        <div className="resource" style={{margin: '0.5rem'}}>
          <label>{LS.error.noValues}</label>
          <p style={{fontSize: '11px', margin: 0}}>Sense ID {value.uri}</p>
        </div>
      );
    }

    return (
      <div className={style} aria-label="value">
        <ul>
          {
            fields.map((v, k) => 
              <FieldDisplay field={v} key={k}
                shaded={isShaded} depth={depth + 1} mode={mode}/>
            )
          }
          {
            displayLinksEnabled && value.isArchivedObject &&
            <ObjectLink label={field.label} uri={value.uri} link={`displayObject.do?uri=${value.uri}`} />
          }
        </ul>
      </div>
    );
  };
  
  // The Resource contains nested resources (recursive display)
  if (isObject(values[0])) {
    return (
      <div style={{margin: 0}} aria-label="resource">
        {
          values.map((value, i) => (
            <div className='resource' key={i} >
              <Header field={field} type='resource' />
              <NestedResource value={value}/>
            </div>
          ))
        }
      </div>
    );
  }

  // The Resource contains literals
  return <LiteralDisplay field={field} mode={mode} />;
}

// without printMode, toggle shading background for every other resource
const getStyle = (isShaded, depth) => {
  let subClass = 'resource ' + (isShaded ? 'shaded' : 'bg-white');
  if (depth === 0) {
    subClass += ' resource-root ';
  }
  return subClass;
};